import React, { Component } from "react";
import Session from "../../Service/Session";
import ContentLoader from "react-content-loader";
import WorkFlowManager from "../../WorkFlowManager";
import { Grid } from "@material-ui/core";
import MobileFooter from "../Common/Profile/MobileFooter";
const $ = window.jQuery;

export default class index extends Component {
  // NOSONAR

  componentDidMount() {
    const tenant = Session.get("TENANT");

    const selectedWorkFlowID = this.props.idOfWorkflowSelected;
    const selectedWorkFlow = tenant.bpmn_deployments.find(
      (bpmn_deployment) =>
        bpmn_deployment.loan_workflow_id === selectedWorkFlowID
    );
    const containerId = "#workflow-container";
    const workFlowManager = new WorkFlowManager(
      selectedWorkFlow.process_definition_id,
      containerId,
      tenant
    );

    workFlowManager.load();
    $(document).on("language-changed", () => {
      workFlowManager.load();
    });
  }

  componentWillUnmount() {
    $(document).unbind("language-changed");
  }

  render() {
    return (
      <>
        <div id="workflow-container">
          <div className="demo-container mdl-grid">
            <div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
            <div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
              <div className="mdl-grid center-items">
                <div className="mdl-cell mdl-cell--10-col">
                  <div className="text-center">
                    <ContentLoader
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                      height={160}
                      id="responsive-loader"
                      speed={2}
                      viewBox="0 0 400 160"
                      width={400}
                    >
                      <rect
                        height="48"
                        rx="21"
                        ry="21"
                        width="196"
                        x="1"
                        y="106"
                      />
                      <rect
                        height="48"
                        rx="21"
                        ry="21"
                        width="196"
                        x="201"
                        y="106"
                      />
                      <rect
                        height="14"
                        rx="6"
                        ry="6"
                        width="381"
                        x="6"
                        y="22"
                      />
                      <rect
                        height="15"
                        rx="5"
                        ry="5"
                        width="261"
                        x="68"
                        y="54"
                      />
                    </ContentLoader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          <Grid sx={12} sm={6} item style={{ margin: "0 auto" }}>
            <MobileFooter hasBack={false} />
          </Grid>
        }
      </>
    );
  }
}
